import styled from 'styled-components'

const MyDiv = styled.div`
.select_box{
    width: 100px;
    margin-left: 15px;
    height: 34px;
    border: 1px solid #cecece;
    font-size: 14px;
    font-family: "Arial";
}
.select_box:focus-visible{
    outline: 0;
}
.ka-paging-sizes{
    align-items: center;
}
`
export default MyDiv
